import { FULFILMENT_PASS_USER_LOADED } from '../../actionTypes/fulfilmentPassActionTypes'

const initialState = {
  hasFetchedUserDetails: false,
  userId: null
}

export const fulfilmentPassReducer = (state = initialState, action) => {
  switch (action.type) {
    case FULFILMENT_PASS_USER_LOADED:
      return {
        ...state,
        hasFetchedUserDetails: true,
        userId: action.payload?.userId || null
      }
    default:
      return state
  }
}
